import { useEffect } from "react"
import type { MarkerInstance } from "react-map-gl/mapbox"

import type { MarkerEventHandler } from "../typings"

export const useMarkerEvent = <TEvent extends keyof HTMLElementEventMap>(
	marker: MarkerInstance | undefined,
	type: TEvent,
	handler: MarkerEventHandler<HTMLElementEventMap[TEvent]>,
) => {
	useEffect(() => {
		if (!marker) return

		const element = marker.getElement()

		const abortController = new AbortController()

		element.addEventListener(
			type,
			(event) => {
				handler?.({
					type,
					originalEvent: event,
					target: marker,
				})
			},
			{
				signal: abortController.signal,
			},
		)

		return () => {
			abortController.abort()
		}
	}, [handler, marker, type])
}
